export default __webpack_public_path__ + "static/media/cmp-app-perks-tab.6bea5aeb.png";